import Checklist from '@/views/checklist'
import ListChecklist from '@/views/checklist/list'
import CreateChecklist from '@/views/checklist/create'
import EditChecklist from '@/views/checklist/edit'
import ViewChecklist from '@/views/checklist/view'
import ChecklistChecklistItem from '@/views/checklist/checklist-item'
import SumaryChecklist from '@/views/checklist/view/summaryChk'
import AuditResultChecklist from '@/views/checklist/view/AuditResult'
import SumaryDetailChecklist from '@/views/checklist/view/summary-history/detail'
import SumaryHistory from '@/views/checklist/view/summary-history/list'
import Corrective from '@/views/checklist/corrective'
import ReportFix from '@/views/checklist/report-fix'

export default {
  path: 'checklist',
  component: Checklist,
  redirect: 'checklist/list',
  name: 'checklist.auditting',
  children: [
    {
      path: 'list',
      name: 'checklist.list',
      component: ListChecklist
    },
    {
      path: 'create',
      name: 'checklist.create',
      component: CreateChecklist
    },
    {
      path: ':checklist_id/corrective',
      name: 'Checklist',
      component: Corrective
    },
    {
      path: ':checklist_id/corrective-result',
      name: 'summary.result_corrective',
      component: ReportFix
    },
    {
      path: ':checklist_id/edit',
      name: 'checklist.update',
      component: EditChecklist
    },
    {
      path: ':checklist_id/checklist-item',
      name: 'checklist.attribute.add_checklist_item',
      component: ChecklistChecklistItem
    },
    {
      path: ':checklist_id/view',
      name: 'Checklist',
      component: ViewChecklist
    },
    {
      path: ':checklist_id/summary',
      name: 'checklist.attribute.summary',
      component: SumaryChecklist
    },
    {
      path: ':checklist_id/summary/history',
      name: 'checklist.attribute.history_summary',
      component: SumaryHistory
    },
    {
      path: ':checklist_id/summary/:summary_id',
      name: 'checklist.attribute.summary',
      component: SumaryDetailChecklist
    },
    {
      path: ':checklist_id/audit-result',
      name: 'checklist.attribute.audit_result',
      component: AuditResultChecklist
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/checklists/checklist.js